// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.courier-process-page {
    font-family: "Open Sans", sans-serif;
  }
  
  .tabs-bar {
    display: flex;
    border-bottom: 2px solid #ccc;
    font-weight: bold;
    padding-top:10px;
  }
  
  .tab-item {
    padding: 10px 20px;
    cursor: pointer;
    border: 1px solid transparent;
    border-bottom: 2px solid transparent;
    margin-right: 5px;
  }
  
  .tab-item.active {
    border-bottom: 2px solid #03c9d7;
    font-weight: bold;
    color: #03c9d7;
  }
  
  .tab-content {
    padding: 20px;
    border: 1px solid #ccc;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/CourierProcessPage.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB","sourcesContent":[".courier-process-page {\r\n    font-family: \"Open Sans\", sans-serif;\r\n  }\r\n  \r\n  .tabs-bar {\r\n    display: flex;\r\n    border-bottom: 2px solid #ccc;\r\n    font-weight: bold;\r\n    padding-top:10px;\r\n  }\r\n  \r\n  .tab-item {\r\n    padding: 10px 20px;\r\n    cursor: pointer;\r\n    border: 1px solid transparent;\r\n    border-bottom: 2px solid transparent;\r\n    margin-right: 5px;\r\n  }\r\n  \r\n  .tab-item.active {\r\n    border-bottom: 2px solid #03c9d7;\r\n    font-weight: bold;\r\n    color: #03c9d7;\r\n  }\r\n  \r\n  .tab-content {\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
